import { render, staticRenderFns } from "./PlanForm.vue?vue&type=template&id=255e5c05&scoped=true&"
import script from "./PlanForm.vue?vue&type=script&lang=js&"
export * from "./PlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255e5c05",
  null
  
)

export default component.exports